import GestorSesionesContainer from './containers/gestor-sesiones-container';
export default GestorSesionesContainer;